import React, { Component } from 'react';
import i18n from 'app/common/i18n';

import InputCurrency from './input-currency';
import TextField from '@mui/material/TextField';
import InputAdornment from '@mui/material/InputAdornment';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';

// TODO: Fix styling (blue color is off; and underline should be more grey)
// TODO: Look at signup form and error... eg. errorText

class Input extends Component {
  constructor(props) {
    super(props);

    this.state = {
      length: props.value
        ? props.value.length
        : props.defaultValue
        ? props.defaultValue.length
        : 0
    };
  }

  handleChange = (ev) => {
    // TODO: something about NOT using ev.target ?
    const length = ev.target.value.length;
    this.setState({ length });
    this.props.onChange(ev);
  };

  render() {
    if (this.props.multiline || this.props.type === 'textarea') {
      const {
        error, // eslint-disable-line no-unused-vars
        i18n, // eslint-disable-line no-unused-vars
        withState,
        ...props
      } = this.props;

      return (
        <TextField
          error={Boolean(error)}
          style={{ marginBottom: 24 }}
          InputLabelProps={{ shrink: true }}
          {...(withState ? withState(props, this.state) : props)}
          onChange={this.handleChange}
        />
      );
    }

    const {
      i18n,
      error,
      InputLabelProps = {},
      InputProps = {},
      inputProps = {},
      startAdornment,
      endAdornment,
      withState,
      errorText,
      anonymousProps,
      ...props
    } = this.props;

    const nextInputProps = { ...InputProps };

    if (anonymousProps) {
      const { isAnonymous, label, onClick } = anonymousProps;
      props.helperText = (
        <FormControlLabel
          style={{ marginLeft: '-5px' }}
          control={
            <Checkbox
              style={{ padding: '6px' }}
              color="primary"
              checked={isAnonymous}
              name="anonymous"
              onClick={onClick}
            />
          }
          label={label}
        />
      );
    }

    if (errorText || error) {
      props.helperText = errorText
        ? errorText
        : typeof error === 'string'
        ? error
        : error.message;
    }

    if (props.type === 'currency') {
      return <InputCurrency {...this.props} helperText={props.helperText} />;
    }

    if (startAdornment) {
      nextInputProps.startAdornment =
        typeof startAdornment === 'string' ? (
          <InputAdornment position="start">{startAdornment}</InputAdornment>
        ) : (
          startAdornment
        );
    }

    if (endAdornment) {
      nextInputProps.endAdornment =
        typeof endAdornment === 'string' ? (
          <InputAdornment position="end">{endAdornment}</InputAdornment>
        ) : (
          endAdornment
        );
    }

    return (
      <TextField
        error={Boolean(error)}
        style={props.removeMargin ? {} : { marginBottom: 24 }}
        inputProps={{
          ...inputProps,
          style: { height: '1.1875em', ...(inputProps.style || {}) }
        }}
        InputProps={nextInputProps}
        InputLabelProps={{ shrink: true, ...InputLabelProps }}
        FormHelperTextProps={{
          error: errorText || error ? true : false
        }}
        {...(withState ? withState(props, this.state) : props)}
        onChange={this.handleChange}
      />
    );
  }
}

export default i18n(Input);